import classNames from 'classnames/bind';
import { useIntl } from 'react-intl';
import { Label } from '@entur/typography';
import { ActionChip } from '@entur/chip';
import { CheckIcon } from '@entur/icons';
import { LegacyColumns } from '../types';
import styles from '../styles.module.scss';
import { FilterModalColumn } from '../hooks/useClientFilter';

const cx = classNames.bind(styles);

// Accounting-specific columns that get dedicated filter chips in the TAccount view.
const FILTER_CHIPS = [
  'transOrderId',
  'transOrderVersion',
  'acctCtx_s1',
  'acctCtx_s2',
  'acctCtx_s3',
  'acctCtx_s4',
  'acctCtx_s5',
];

interface TAccountFilterChipsProps {
  columns: LegacyColumns;
  columnHasFilter: (columnKey: string) => boolean;
  openFilterModal: (column: FilterModalColumn) => void;
}

export const TAccountFilterChips = ({ columns, columnHasFilter, openFilterModal }: TAccountFilterChipsProps) => {
  const intl = useIntl();

  return (
    <div>
      <Label>{intl.formatMessage({ id: 'generalValues.filterBy' })}</Label>
      <div className={styles.chipWrapper}>
        {FILTER_CHIPS.filter((f) => columns[f]).map((f) => {
          const column = columns[f];
          const hasFilter = columnHasFilter(f);
          const label = column.text || f;
          return (
            <ActionChip
              key={f}
              className={cx({ filterIsActive: hasFilter })}
              onClick={() => openFilterModal({ key: f, label: label.replace(/\|/g, ''), config: column })}
            >
              {hasFilter && <CheckIcon />} {intl.formatMessage({ id: `chips.${f}`, defaultMessage: label })}
            </ActionChip>
          );
        })}
      </div>
    </div>
  );
};
